import { InjectionToken } from '@angular/core';
import { MarketTimeDataConfig } from '@prlw/data/market-time/market-time-data.module';

export const MARKET_TIME_DATA_CONFIG = new InjectionToken<MarketTimeDataConfig>(
  'market-time-data-config',
);
